import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/images/perma_default_logo.png'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-full absolute right-0 md:opacity-70 opacity-60",
  alt: "perma default logo"
}, null, -1)
const _hoisted_3 = { class: "flex items-center pt-6 flex-col" }
const _hoisted_4 = { class: "flex items-center w-full" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "text-14px text-permaWhite2 flex items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "font-space-gtotesk-medium text-2xl"
}
const _hoisted_11 = {
  key: 1,
  class: "font-space-gtotesk-medium text-2xl"
}

import { computed } from 'vue'
import Dashed from '@/components/common/Dashed.vue'
import { useI18n } from 'vue-i18n'
import { isProd } from '@/constants'
interface Props {
  nftNum: number
  amount: string
  displayAssetsBalance: boolean
}
interface Emits {
  (e:'close'):void
  (e:'switch'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    nftNum: null,
    amount: null,
    displayAssetsBalance: null
  },
  emits: ["close", "switch"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e:'close'):void
  (e:'switch'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  nftNum: number
  amount: string
  displayAssetsBalance: boolean
}

const { t } = useI18n()


const userlist = computed(() => {
  return [
    {
      context: props.amount,
      title: t('total_balance') + '($)'
    },
    {
      context: props.nftNum,
      title: 'NFT'
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userlist), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["flex flex-col items-start relative", index === 0 ? 'min-w-158px' : 'ml-12'])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                (item.title !== 'NFT')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: require(`@/images/${__props.displayAssetsBalance ? 'eye-open' : 'eye-close'}.png`),
                      alt: "eye",
                      class: "ml-1 cursor-pointer",
                      style: {"height":"22px"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('switch')))
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              (item.title === 'NFT')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `https://app${_unref(isProd) ? '' : '-dev'}.permaswap.network/nft`,
                    target: "_blank",
                    class: "text-14px text-permaYellow hover:text-permaYellow2 active:text-permaYellow3 cursor-pointer flex items-center"
                  }, [
                    _createElementVNode("i", {
                      class: "el-icon-top-right text-14px",
                      style: {"font-weight":"700"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
                    })
                  ], 8, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (item.title === 'NFT')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(!__props.displayAssetsBalance ? item.context : '**'), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(!__props.displayAssetsBalance ? item.context : '******'), 1))
            ])
          ], 2))
        }), 128))
      ]),
      _createVNode(Dashed, { class: "h-px w-full mt-6 user_dashed" })
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})